<mat-form-field [appearance]="matAppearance">
  <mat-label>{{ label }}</mat-label>
  <input [id]="componentId" matInput [formControl]="fc" [errorStateMatcher]="errorMatcher" trim="blur" />
  <mat-error *ngFor="let item of fc.errors | keyvalue">
    {{ item.value }}
  </mat-error>
</mat-form-field>
